import { client } from '@/services/api/axios.ts';
import { useQuery } from '@tanstack/react-query';
import { DeviceTypeNames } from '@/features/devices/schemas/devices.schemas.ts';

export type GetPlantDeviceParameterChartResponse = {
  time: string;

  [parameterName: string]: string | number;
}[];

export const useGetPlantDeviceParameterChartQuery = ({
  plantId,
  deviceType,
  deviceSN,
  parameter,
  dateRange,
}: {
  plantId: string;
  deviceType: DeviceTypeNames;
  deviceSN?: string;
  parameter: number;
  dateRange: {
    startDate: Date;
    endDate: Date;
  };
}) => {
  return useQuery({
    queryKey: [
      'plants',
      plantId,
      'overview',
      deviceType,
      deviceSN,
      parameter,
      dateRange.startDate,
      dateRange.endDate,
    ],
    queryFn: async () => {
      const { data } = await client.get<{
        body: GetPlantDeviceParameterChartResponse;
      }>(`/plants/${plantId}/devices/overview`, {
        params: {
          deviceType,
          deviceSN,
          parameter,
          startDate: `${new Date(dateRange.startDate).getTime()}`,
          endDate: `${new Date(dateRange.endDate).getTime()}`,
        },
      });

      return data?.body;
    },
    refetchInterval: 1000 * 60,
    retry: 1,
  });
};
